export type DELDivision = "All";

export interface DELTeam {
  id: string;
  name: string;
  nameDe: string;
  abbr: string;
  city: string;
  logo: string;
  division: DELDivision;
}

// DEL team logos from TheSportsDB
const DEL_LOGOS: Record<string, string> = {
  "1": "https://r2.thesportsdb.com/images/media/team/badge/0hcu2e1656771458.png",   // Eisbären Berlin
  "2": "https://r2.thesportsdb.com/images/media/team/badge/qlxy761656771275.png",   // Adler Mannheim
  "3": "https://r2.thesportsdb.com/images/media/team/badge/yq8q0g1656771525.png",   // EHC Red Bull München
  "4": "https://r2.thesportsdb.com/images/media/team/badge/2y72hx1656771512.png",   // Kölner Haie
  "5": "https://r2.thesportsdb.com/images/media/team/badge/f1jjsy1656771438.png",   // Düsseldorfer EG
  "6": "https://r2.thesportsdb.com/images/media/team/badge/jdvv0c1656771488.png",   // Grizzlys Wolfsburg
  "7": "https://r2.thesportsdb.com/images/media/team/badge/qf47pu1656771578.png",   // Straubing Tigers
  "8": "https://r2.thesportsdb.com/images/media/team/badge/1x09ox1656771545.png",   // Nürnberg Ice Tigers
  "9": "https://r2.thesportsdb.com/images/media/team/badge/6j0bho1656771565.png",   // Schwenninger Wild Wings
  "10": "https://r2.thesportsdb.com/images/media/team/badge/w5q5r81656771302.png",  // Augsburger Panther
  "11": "https://r2.thesportsdb.com/images/media/team/badge/r7aexn1656771499.png",  // Iserlohn Roosters
  "12": "https://r2.thesportsdb.com/images/media/team/badge/a4ky3h1656771337.png",  // Pinguins Bremerhaven
  "13": "https://r2.thesportsdb.com/images/media/team/badge/50gcfq1656771472.png",  // Löwen Frankfurt
  "14": "https://r2.thesportsdb.com/images/media/team/badge/rrmzq91656771478.png",  // ERC Ingolstadt
};

const getDELLogo = (teamId: string) => DEL_LOGOS[teamId] ?? "";

export const DEL_TEAMS: DELTeam[] = [
  { id: "1", name: "Eisbären Berlin", nameDe: "Eisbären Berlin", abbr: "EBB", city: "Berlin", logo: getDELLogo("1"), division: "All" },
  { id: "2", name: "Adler Mannheim", nameDe: "Adler Mannheim", abbr: "MAN", city: "Mannheim", logo: getDELLogo("2"), division: "All" },
  { id: "3", name: "EHC Red Bull München", nameDe: "EHC Red Bull München", abbr: "MUN", city: "Munich", logo: getDELLogo("3"), division: "All" },
  { id: "4", name: "Kölner Haie", nameDe: "Kölner Haie", abbr: "KOL", city: "Cologne", logo: getDELLogo("4"), division: "All" },
  { id: "5", name: "Düsseldorfer EG", nameDe: "Düsseldorfer EG", abbr: "DEG", city: "Düsseldorf", logo: getDELLogo("5"), division: "All" },
  { id: "6", name: "Grizzlys Wolfsburg", nameDe: "Grizzlys Wolfsburg", abbr: "WOB", city: "Wolfsburg", logo: getDELLogo("6"), division: "All" },
  { id: "7", name: "Straubing Tigers", nameDe: "Straubing Tigers", abbr: "STR", city: "Straubing", logo: getDELLogo("7"), division: "All" },
  { id: "8", name: "Nürnberg Ice Tigers", nameDe: "Nürnberg Ice Tigers", abbr: "NIT", city: "Nuremberg", logo: getDELLogo("8"), division: "All" },
  { id: "9", name: "Schwenninger Wild Wings", nameDe: "Schwenninger Wild Wings", abbr: "SWW", city: "Villingen-Schwenningen", logo: getDELLogo("9"), division: "All" },
  { id: "10", name: "Augsburger Panther", nameDe: "Augsburger Panther", abbr: "AUG", city: "Augsburg", logo: getDELLogo("10"), division: "All" },
  { id: "11", name: "Iserlohn Roosters", nameDe: "Iserlohn Roosters", abbr: "IEC", city: "Iserlohn", logo: getDELLogo("11"), division: "All" },
  { id: "12", name: "Pinguins Bremerhaven", nameDe: "Pinguins Bremerhaven", abbr: "BRH", city: "Bremerhaven", logo: getDELLogo("12"), division: "All" },
  { id: "13", name: "Löwen Frankfurt", nameDe: "Löwen Frankfurt", abbr: "FRA", city: "Frankfurt", logo: getDELLogo("13"), division: "All" },
  { id: "14", name: "ERC Ingolstadt", nameDe: "ERC Ingolstadt", abbr: "ING", city: "Ingolstadt", logo: getDELLogo("14"), division: "All" },
];

export const DEL_DIVISIONS: DELDivision[] = ["All"];

export const getDELTeamByAbbr = (abbr: string): DELTeam | undefined => {
  return DEL_TEAMS.find((team) => team.abbr === abbr);
};
